import { z } from 'zod';

import { messages } from './StepBackupEmail.messages';

export const schema = z.object({
    email: z.string().trim().min(1, messages.errorEmailEmpty).email(messages.errorEmailInvalid),
});
